var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInteligence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#6F4595;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st0",
    d: "M144.3,60.2c-9.9,0-18-8.4-18-18.8c0-10.4,8.1-18.8,18-18.8s18,8.4,18,18.8 C162.3,51.7,154.3,60.2,144.3,60.2z M144.3,30.3c-5.7,0-10.3,5-10.3,11.1c0,6.1,4.6,11.1,10.3,11.1c5.7,0,10.3-5,10.3-11.1 C154.6,35.2,150,30.3,144.3,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st0",
    d: "M144.3,185.8c-2.1,0-3.9-1.7-3.9-3.9v-52.1c0-2.1,1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9v52.1 C148.2,184,146.5,185.8,144.3,185.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st0",
    d: "M160.1,185.8h-31.6c-2.1,0-3.9-1.7-3.9-3.9V88.4C101.8,83.8,86,69.6,78.8,57.5 c-3.1-5.2-1.9-11.9,2.9-15.6c4.7-3.7,11.5-3.3,15.7,0.9c14.3,14.3,28.9,20.2,31.9,21.3h30.2c2.9-1.1,17.5-7,31.9-21.3 c4.2-4.2,10.9-4.6,15.7-0.9c4.8,3.7,6,10.4,2.9,15.6c-7.3,12.1-23,26.3-45.9,30.9v93.5C164,184,162.3,185.8,160.1,185.8z M132.4,178h23.8V85.2c0-1.9,1.4-3.5,3.3-3.8c22-3.5,37-16.7,43.8-27.8c1.1-1.8,0.7-4.2-1-5.5c-1.7-1.3-4-1.2-5.4,0.3 c-17.3,17.3-34.7,23.2-35.5,23.4c-0.4,0.1-0.8,0.2-1.2,0.2h-31.6c-0.4,0-0.8-0.1-1.2-0.2c-0.7-0.2-18.1-6.1-35.5-23.4 c-1.4-1.4-3.8-1.6-5.4-0.3c-1.7,1.3-2.1,3.7-1,5.5c6.7,11.2,21.7,24.4,43.8,27.8c1.9,0.3,3.3,1.9,3.3,3.8V178z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st0",
    d: "M195.8,223.4H92.9c-2.1,0-3.9-1.7-3.9-3.9v-18.8c0-2.1,1.7-3.9,3.9-3.9h13v-14.9 c0-2.1,1.7-3.9,3.9-3.9h69.1c2.1,0,3.9,1.7,3.9,3.9v14.9h13c2.1,0,3.9,1.7,3.9,3.9v18.8C199.7,221.6,197.9,223.4,195.8,223.4z M96.8,215.6h95.2v-11h-13c-2.1,0-3.9-1.7-3.9-3.9v-14.9h-61.3v14.9c0,2.1-1.7,3.9-3.9,3.9h-13V215.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st0",
    d: "M233.4,260.9H55.3c-2.1,0-3.9-1.7-3.9-3.9v-18.8c0-2.1,1.7-3.9,3.9-3.9h13.5v-14.9 c0-2.1,1.7-3.9,3.9-3.9H216c2.1,0,3.9,1.7,3.9,3.9v14.9h13.5c2.1,0,3.9,1.7,3.9,3.9v18.8C237.3,259.2,235.5,260.9,233.4,260.9z M59.2,253.2h170.3v-11H216c-2.1,0-3.9-1.7-3.9-3.9v-14.9H76.6v14.9c0,2.1-1.7,3.9-3.9,3.9H59.2V253.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M243.7,260.9H45c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9h198.8c2.1,0,3.9,1.7,3.9,3.9 C247.6,259.2,245.9,260.9,243.7,260.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M216,242.1H97.6c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9H216c2.1,0,3.9,1.7,3.9,3.9 C219.9,240.4,218.1,242.1,216,242.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M153,204.6h-43.2c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9H153c2.1,0,3.9,1.7,3.9,3.9 C156.9,202.8,155.2,204.6,153,204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M216.2,134.2c-2.1,0-3.9-1.7-3.9-3.9v-18.2c0-1.5,0.9-2.9,2.3-3.5c1.4-0.6,3-0.4,4.2,0.6 l5.8,5.1c1.6,1.4,1.8,3.9,0.4,5.5c-1.2,1.4-3.3,1.7-4.9,0.8v9.7C220,132.5,218.3,134.2,216.2,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M216.2,134.2c-2.1,0-3.9-1.7-3.9-3.9v-9.7c-1.6,0.9-3.6,0.6-4.9-0.8c-1.4-1.6-1.2-4.1,0.4-5.5 l5.8-5.1c1.1-1,2.8-1.2,4.2-0.6c1.4,0.6,2.3,2,2.3,3.5v18.2C220,132.5,218.3,134.2,216.2,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M72.5,134.2c-2.1,0-3.9-1.7-3.9-3.9v-9.7c-1.6,0.9-3.6,0.6-4.9-0.8c-1.4-1.6-1.2-4.1,0.4-5.5 l5.8-5.1c1.1-1,2.8-1.2,4.2-0.6c1.4,0.6,2.3,2,2.3,3.5v18.2C76.4,132.5,74.7,134.2,72.5,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M72.5,134.2c-2.1,0-3.9-1.7-3.9-3.9v-18.2c0-1.5,0.9-2.9,2.3-3.5c1.4-0.6,3-0.4,4.2,0.6l5.8,5.1 c1.6,1.4,1.8,3.9,0.4,5.5c-1.2,1.4-3.3,1.7-4.9,0.8v9.7C76.4,132.5,74.7,134.2,72.5,134.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteligence);
export default __webpack_public_path__ + "static/media/intéligence.fbc51d10e3e84e258ecc0b40274c97fd.svg";
export { ForwardRef as ReactComponent };